export default __webpack_public_path__ + "static/media/febest_ws_logo_red.fe3d7271.svg";